import api from './api';

export type HolidayCalendarType =
  | 'LEGAL_HOLIDAY'
  | 'WEEKEND_ADJUSTMENT'
  | 'MAKEUP_WORK'
  | 'WORKDAY';

export interface HolidayCalendarEntry {
  calendarDate: string;
  isWorkday: boolean;
  holidayName: string | null;
  holidayType: HolidayCalendarType;
  calendarSource: 'PRIMARY' | 'SECONDARY' | 'MANUAL';
  notes: string | null;
  salaryMultiplier: number;
  salaryOverride: boolean;
  salarySource: 'CALENDAR_DEFAULT' | 'RULE_ENGINE' | 'MANUAL' | 'IMPORTED' | 'API';
  updatedAt: string | null;
}

export interface HolidayCalendarYearView {
  site: {
    publicId: string;
    siteCode: string;
    siteName: string;
    siteStatus: string;
  };
  year: number;
  entries: HolidayCalendarEntry[];
}

export interface UpdateHolidayCalendarPayload {
  isWorkday: boolean;
  holidayName: string | null;
  holidayType: HolidayCalendarType;
  notes: string | null;
  salaryOverride: boolean;
  salaryMultiplier: number;
}

interface Envelope<T> {
  success: boolean;
  data: T;
}

export const holidayCalendarApi = {
  listYear: (sitePublicId: string, year: number) =>
    api
      .get<Envelope<HolidayCalendarYearView>>(
        `/platform/sites/${sitePublicId}/holiday-calendar`,
        { params: { year } },
      )
      .then((response) => response.data.data),

  updateDate: (
    sitePublicId: string,
    calendarDate: string,
    payload: UpdateHolidayCalendarPayload,
  ) =>
    api
      .put<Envelope<HolidayCalendarEntry>>(
        `/platform/sites/${sitePublicId}/holiday-calendar/${calendarDate}`,
        payload,
      )
      .then((response) => response.data.data),
};

export default holidayCalendarApi;
